<div class="mfa-onboarding">
  Reporting using the <strong>GBGO® firstconnect</strong> platform online now requires 2-step
  verification or Multi-Factor Authentication (MFA).
  <br><br>
  Users who submit losses must use Gallagher Bassett’s new security measures, designed to keep your
  important information safe and secure. We no longer support shared passwords.
  <br><br>
  Follow these easy instructions by
  <a href="https://cdn.gbgofirstconnect.com/FirstConnectLoginMFA.pdf"
    target="_blank"
    rel="noopener noreferrer">downloading this guide</a>, <span class="d-inline-block">or call 877-747-9322 for assistance.</span>
</div>
